import localStorageHelper from './localStorageHelper'
import localStorageIds from '../constants/localStorageIds'
import isUserAddonsValid from './isUserAddonsValid'

const userHasOnlySpecificAddons = (allowedAddons) => {
  const { localStorageValue: userAddons } = localStorageHelper(localStorageIds.ADDONS)
  const { localStorageValue: selectedOrg } = localStorageHelper(localStorageIds.SELECTED_ORG)

  if (!userAddons[selectedOrg?.id]) return false

  return (
    isUserAddonsValid(allowedAddons) && userAddons[selectedOrg?.id].length === allowedAddons.length
  )
}

export default userHasOnlySpecificAddons
